//import ccbReducer from "../../modules/ccbquery/store/reducer"
//import { disclaimerReducer } from "../disclaimer/reducer"
// import filestoreListReducer from "../../modules/filestores/store/reducer"
// import profileReducer from "../../modules/profile/reducer"
// import settingReducer from "../../modules/settings/reducer"

import { OptionCl } from "../../../components/select-cl"
import { COUNTRY_DOMAIN } from "../../../domains/ccb/country/service"
import { CURRENCYSHORT_DOMAIN, CURRENCY_DOMAIN } from "../../../domains/ccb/currency/service"
import { CASH_CORRESPONDENT_DOMAIN } from "../../../domains/ccb/cashcorrespondent/service"
import { CITY_DOMAIN } from "../../../domains/ccb/city/service"




export type CcbCriteriaState = {
    allDomainsLoaded: boolean,
    error?: string,
    countries?: OptionCl[] ,
    cities? : OptionCl[],
    currencies?: OptionCl[],
    currenciesShort?: OptionCl[],
    cashCorrespondents?: OptionCl[]
}


export  type CcbCriteriaAction =
    {
        type: "CcbCriteria/DOMAINLOADED",
        payload: OptionCl[], 
        domain: string
    } | {
        type: "CcbCriteria/FETCHERROR",
        payload: string 
    }
  
    const initialState: CcbCriteriaState = { allDomainsLoaded: false }

    const getAllDomainsLoaded = ( state : CcbCriteriaState ) : boolean => {
        // console.log( "CCb criteria reducer.ts in getAllDomainsLoaded "  + JSON.stringify(state) + " tms:" + Date.now() )
        return (typeof state.cities !== "undefined") && (state.cities !== null ) && 
            (typeof state.currencies !== "undefined") && (state.currencies !== null ) && 
            (typeof state.currenciesShort !== "undefined") && (state.currenciesShort !== null ) && 
            (typeof state.cashCorrespondents !== "undefined") && (state.cashCorrespondents !== null ) && 
            (typeof state.countries !== "undefined") && (state.countries !== null ) 
    }


export const ccbCriteriaReducer = (
        state: CcbCriteriaState = initialState,
        action: CcbCriteriaAction 
    ) => {
        switch (action.type) {
            case "CcbCriteria/DOMAINLOADED":
                //console.log("Ccb Criteria Reducer.ts state" + JSON.stringify(state) + " tms:" + Date.now())
                //console.log("Ccb Criteria Reducer.ts received action" + JSON.stringify(action) + " tms:" + Date.now())
                if ( action.domain === COUNTRY_DOMAIN) {  
                    const newState = { ...state, countries: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === CASH_CORRESPONDENT_DOMAIN ) {
                    const newState = { ...state, cashCorrespondents: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === CITY_DOMAIN) {
                    const newState = { ...state, cities: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === CURRENCY_DOMAIN ) {
                    const newState = { ...state, currencies: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === CURRENCYSHORT_DOMAIN ) {
                    const newState = { ...state, currenciesShort: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else {
                    console.warn("Ccb Criteria reducer.ts: Unrecognized domain [" + action.domain + "]")
                    return state;
                }
                //return { ...state, countries: action.payload, allDomainsLoaded: true }
            case "CcbCriteria/FETCHERROR" :    
                return {
                    ...state,
                    allDomainsLoaded: false,
                    error: action.payload
                  };
            default: return state;
        }
    }
    